import { IsString, Matches } from 'class-validator';

import { EmailDto } from './email.dto';

export class OtpVerifyDto extends EmailDto {
	@IsString()
	@Matches(/^\d{6}$/, { message: 'OTP must be exactly 6 digits' })
	code: string;
}
